import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["displayName", "usageHint", "audience"]
  static values = { url: String }

  connect() {
    if (this.hasAudienceTarget) {
      this.initialAudience = this.audienceTarget.value
    }
  }

  save() {
    const data = {
      whatsapp_template: {
        display_name: this.displayNameTarget.value,
        usage_hint: this.usageHintTarget.value
      }
    }

    if (this.hasAudienceTarget) {
      data.whatsapp_template.audience = this.audienceTarget.value
    }

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken,
        "Accept": "application/json"
      },
      body: JSON.stringify(data)
    })
    .then(response => response.json())
    .then(result => {
      if (result.success) {
        // Si cambió la audiencia, la fila ya no pertenece a esta pestaña.
        if (this.hasAudienceTarget && result.audience !== this.initialAudience) {
          window.location.reload()
          return
        }
        this.element.classList.add("table-success")
        setTimeout(() => this.element.classList.remove("table-success"), 1000)
      }
    })
    .catch(() => {
      this.element.classList.add("table-danger")
      setTimeout(() => this.element.classList.remove("table-danger"), 2000)
    })
  }
}
